<template>
  <div :class="'search float-'+float">
    <b-input-group class="my-3">
      <b-form-input
          type="text"
          :value="value"
          @input="updateValue($event)"
          :placeholder="placeholder"
          @keyup.enter="searchHandler()">
      </b-form-input>
      <b-input-group-append>
        <b-input-group-text class="searchinput">
          <b-icon icon="search" @click="searchHandler()" />
        </b-input-group-text>
      </b-input-group-append>
    </b-input-group>
  </div>
</template>
<script>
export default {
  name: "SearchItems",
  props: {
    searchHandler: {
      type: Function,
      default: () => {
        console.warn("searchHandler prop is missing. This prop expect functionss")
      }
    },
    float:{
      Type: String,
      default: "right"
    },
    placeholder:{
      type: String,
      default: 'Type To Search',
    },
    value:{
      type: String,
      default: "",
    },
  },
  data() {
    return {}
  },
  methods: {
    updateValue: function (value) {
      this.$emit('input', value)
    }
  }
}
</script>
<style lang="scss" scoped>
.searchinput {
  cursor: pointer;
}
</style>